import ApiClient from '@/api/ApiClient';
import BaseService from './BaseService';

class CourseModuleService extends BaseService {
    #prefixUrl = 'api/module/';

    constructor() {
        super();
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Saves course module by creating or updating
     * Obs: if uuid is sent, updates module
     * @param {object} moduleData
     * @param {string} id - if sent updates module
     * @returns {api/models/Response}
     */
    async saveModule(moduleData = {}, id = null) {
        let response = false;

        if (id) {
            response = await this.api.executeRequest(`/${id}`, moduleData, this.api.methods.PUT);
        } else {
            response = await this.api.executeRequest('/', moduleData, this.api.methods.POST);
        }
        
        return response;
    }

    /**
     * Saves module order
     * @param {object} moduleData
     * @returns {api/models/Response}
     */
    async saveModuleOrder(moduleData = {}) {
        return await this.api.executeRequest(`/order`, moduleData, this.api.methods.POST);
    }

    /**
     * Removes Module
     * @param {integer} id
     * @returns {api/models/Response}
     */
    async removeCourseModule(id = null) {
        return await this.api.executeRequest(`/${id}`, {}, this.api.methods.DELETE);
    }
}

export default new CourseModuleService();
